import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
// This hack forces React to re-render when `value` changes, even if the object
// reference has not changed. IE: Ignore result of `Object.is` optimization.
function useForceUpdate(initial) {
    const valueRef = useRef(initial);
    const [signal, setSignal] = useState(0);
    const setCallback = useCallback((v) => {
        valueRef.current = v;
        setSignal(s => s + 1);
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return [useMemo(() => valueRef.current, [signal]), setCallback];
}
export function useObservable(observable) {
    const [value, setValue] = useForceUpdate(undefined);
    const [error, setError] = useState(undefined);
    const [done, setDone] = useState(false);
    useEffect(() => {
        const subscription = observable.subscribe({
            next: setValue,
            error: setError,
            complete: () => setDone(true),
        });
        return () => subscription.unsubscribe();
        // Dependencies are un-necessary for this hook.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [value, error, done];
}
//# sourceMappingURL=rxjs.js.map